import React, { forwardRef } from 'react';
import { AlertCircle, Terminal as TermIcon } from 'lucide-react';

const LOG_COLORS = {
  info:    '#9CDCFE',
  success: '#4EC994',
  error:   '#F44747',
  gray:    '#666',
  default: '#CCC',
};

const OutputPanel = forwardRef(function OutputPanel({ buildLogs = [] }, ref) {
  return (
    <div className="h-[150px] border-t border-[#3f3f41] flex flex-col flex-shrink-0">
      <div className="flex h-[26px] bg-[#252526] border-b border-[#3f3f41] flex-shrink-0">
        <div className="flex items-center gap-1 px-3 text-[11px] text-[#ccc] border-b-2 border-[#007ACC]">Output</div>
        <div className="flex items-center gap-1 px-3 text-[11px] text-[#858585] hover:text-[#ccc] cursor-pointer">
          <AlertCircle size={11}/> Error List
          <span className="ml-1 bg-[#333] text-[#888] text-[10px] px-1.5 rounded-full">0</span>
        </div>
        <div className="flex items-center gap-1 px-3 text-[11px] text-[#858585] hover:text-[#ccc] cursor-pointer">
          <TermIcon size={11}/> Terminal
        </div>
        <div className="ml-auto flex items-center px-2 gap-2 text-[#666]">
          <span className="text-[11px] cursor-pointer hover:text-[#ccc]">🗑</span>
        </div>
      </div>
      <div className="flex items-center px-2 py-0.5 border-b border-[#2d2d30] text-[11px] text-[#666] flex-shrink-0 gap-1">
        Show output from:
        <select className="bg-transparent border-none text-[#858585] text-[11px] outline-none cursor-pointer">
          <option>Build</option><option>Debug</option>
        </select>
      </div>
      <div ref={ref} className="flex-1 overflow-y-auto px-2 py-1" style={{ fontFamily: "'Consolas','Courier New',monospace", fontSize: 12, lineHeight: 1.6 }}>
        {buildLogs.length === 0 && (
          <span style={{ color: '#555' }}>Microsoft Visual Studio Version 17.8.3. Copyright (C) Microsoft Corporation.</span>
        )}
        {buildLogs.map((log, i) => (
          <div
            key={i}
            style={{
              color: LOG_COLORS[log.type],
              fontWeight: log.bold ? 600 : 'normal',
              ...(log.bold ? { marginTop: 2 } : {}),
            }}
          >
            {log.text}
          </div>
        ))}
      </div>
    </div>
  );
});

export default OutputPanel;
